import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";
// Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";
//number format plugin
import Autocomplete from "@material-ui/lab/Autocomplete";
import DateFnsUtils from "@date-io/date-fns";
import { format } from "date-fns";
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from "@material-ui/pickers";
import MessageBox from "../../components/MessageBox/MessageBox";
import { SELECTION_CHANGED } from "@material-ui/data-grid";
import CheckPrintTable from "./CheckPrintTable"; //reused table component

import {PDFDownloadLink} from '@react-pdf/renderer';
import {CashVoucherPdf} from "../../components/PDF/CashVoucherPdf";

const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #59b259",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#c1c3d8",
		display:"none"
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(89, 178, 89, 0.09)",
		padding: "1rem",
		border: "1.5px solid #59b259",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #59b259",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
	miniTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#4f537e",
	},
    jchq_color:{
		color: "#4f537e",
	}
});

const CashVoucherPrint = () => {
	const { cvno, branchidno } = useParams();
	const [fundFrom, setFundFrom] = useState([]);
	const [payTo, setPayTo] = useState('');
	const [amount, setAmount] = useState('');
	const [notes, setNotes] = useState('');
	const [cvDetails, setCvDetails] = useState([]);

	const classes = useStyles();

	const [showModal, setShowModal] = useState(false);
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [showPDF, setShowPdf] = useState(false);

	let history = useHistory();
	const [items, setItems] = useState([]); //data to display in table

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
		getCashVoucherDetails();
	}, [x]);
	// useEffect(() => {
	// 	getCashVoucherDetails();
	// }, []);

	const getCashVoucherDetails = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'cv_view_print', {
			params:{
				cvno: cvno,
				jc_u_idno: branchidno
			}
		}).then((res)=>{
			setCvDetails(res.data.data);
			setItems(res.data.data.item);
			setShowPdf(true);
		}).catch((error)=>{
		//console.log(error.message);
		});
	}

	return (
		<div className="page">

			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<NavLink to={"/account"}><h4 style={{color:"#339933"}}>Accounts</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<NavLink to={"/account/cash-voucher-transaction-history"}><h4 style={{color:"#339933"}}>Cash Voucher Listing</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>Cash Voucher Print #{cvno}</h4>
			</div>
			<div className="page-container">
				{/* <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/> */}
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={8}>
								<div>
									<h1>{'Cash Voucher #'+cvno || 'Cash Voucher #'}</h1>
								</div>

								<div>
									<h4>{cvDetails.trandate || 'Trandate'}</h4>
								</div>

								<div>
									<strong>Cash Voucher Information</strong>
								</div>

								<div>
									<h3>{cvDetails.payto || 'Pay To'}</h3>
									   <p>
									   {'Status: '+ cvDetails.status || ''}<br/><br/>
   									   {'Created By: ' + cvDetails.created_by || ''}<br/><br/>
  									   {'Approved By: ' + cvDetails.approved_by || ''}<br/><br/>
									   </p>
								</div>

							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
							</Grid>
							<Grid
							
								item
								xs={2}
								className={classes.buttonContainer}
							>
							</Grid>
							<CheckPrintTable items={items}/>
						</Grid>
					</div>	
					</Card>	
					<div className={classes.buttonContainer}>
						{/* please remove grids etc and button later */}
					{showPDF && <PDFDownloadLink
									document={<CashVoucherPdf cvDetails={cvDetails} items={items[0]}/>}
									fileName={"CashVoucherPrint"+cvno+".pdf"}
									style={{
									textDecoration: "none",
									padding: "6px 8px 10px",
									color: "#fff",
									display:"inline-block",
									marginBottom:"7px",
									fontFamily: "Ubuntu",
									backgroundColor: "#339933",
									border: "1px solid #339933",
									borderRadius: "4px"
									}}
								    >
									{({ blob, url, loading, error }) =>
									loading ? "Loading document..." : "Download Pdf"
									}
					</PDFDownloadLink>}
					</div>		
				</div>
		</div>
	);
};

export default CashVoucherPrint;
